import { NgModule } from '@angular/core';
import { RouterModule } from "@angular/router";
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { LunaCommonModule } from '../common/common.module';

import { AUTH_ROUTES } from "./auth.routes";

import { LoginComponent } from './components/login.component';
import { LogoutComponent } from './components/logout.component';

@NgModule({ declarations: [
        LoginComponent,
        LogoutComponent,
    ], imports: [CommonModule,
        ReactiveFormsModule,
        RouterModule.forChild(AUTH_ROUTES),
        LunaCommonModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AuthModule { }
